import GOES from "./GOES";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthProvider";

interface DynamicLogoProps {
  className?: string;
  fallbackToGoes?: boolean;
}

const DynamicLogo = ({
  className,
  fallbackToGoes = true,
}: DynamicLogoProps) => {
  const { authenticated, initialized, appConfig, configLoaded } = useAuth();
  const [imageError, setImageError] = useState(false);

  // Si no está autenticado, no inicializado, o no se ha cargado la config, mostrar fallback
  if (!authenticated || !initialized || !configLoaded) {
    return fallbackToGoes ? <GOES /> : null;
  }

  // Si tenemos logo dinámico y no hubo error al cargar la imagen, mostrarlo
  if (appConfig?.logo && !imageError) {
    return (
      <img
        src={appConfig.logo}
        alt="Logo de la institución"
        className={`w-8 h-8 object-contain ${className || ""}`}
        onError={() => {
          setImageError(true);
        }}
      />
    );
  }

  // Si hay error, o queremos el fallback, mostrar GOES
  if (fallbackToGoes) {
    return <GOES />;
  }

  // Si no hay logo y no queremos fallback, no mostrar nada
  return null;
};

export default DynamicLogo;
